import { EOrderStatus, IOrderStatusHistoryItem, ITableOrder } from 'models/orders'

// Заказы, созданные до появления status_history, восстанавливаем по сохранённым отметкам времени
const buildFromTimestamps = (order: ITableOrder): IOrderStatusHistoryItem[] => {
  const timestamps: [EOrderStatus, string | undefined][] = [
    [EOrderStatus.ON_CONFIRMATION, order.paid_at],
    [EOrderStatus.CONFIRMED_BY_SELLER, order.order_confirmation_time],
    [EOrderStatus.IN_DELIVERY, order.delivery_preparation_time],
    [EOrderStatus.FINISHED, order.delivery_completion_time]
  ]

  return timestamps
    .filter(([, changedAt]) => Boolean(changedAt))
    .map(([status, changedAt]) => ({ status, changed_at: changedAt as string }))
}

// В истории старого заказа могут быть одни события без статусов — статусы к ним достраиваем
export const getOrderStatusHistory = (order: ITableOrder): IOrderStatusHistoryItem[] => {
  const history = order.status_history ?? []
  if (history.some((item) => item.status)) return history

  return [...buildFromTimestamps(order), ...history].sort(
    (a, b) => new Date(a.changed_at).getTime() - new Date(b.changed_at).getTime()
  )
}
